/** 
 * api接口的统一出口
 */
// 文章模块接口
import search from './search';
import oss from './oss';
// 其他模块的接口……

// 导出接口
export default {
    search, oss
    // ……
}